export const DASHBOARDS_CONFIG = 'dashboards_config'
export const TDR_BANK_CONFIG = 'tdr_bank_config'

export enum DynamicFeatureTogglesTier {
   STAGING = 'staging',
   PRODUCTION = 'production',
   DEVELOPMENT = 'development'
}

// #region dashboards config
export enum DashboardsConfigMode {
   MAINTENANCE = 'MAINTENANCE',
   ACTIVE = 'ACTIVE'
}

export enum DashboardsConfigKeyEnum {
   MODE = 'mode',
   ENABLE_AT = 'enable_at'
}

// #endregion

// #region dashboards config
export enum TDRBankConfigKeyEnum {
   IS_ENABLED = 'is_enabled'
}

// #endregion
